module.exports = __webpack_public_path__ + "img/cat3.ddfc859e.svg";